export default __webpack_public_path__ + "static/media/conor-image.74604299.png";